function flattenJsonForExport(data, childrenKeys = []) {
  const rows = [];

  function getKeys(obj) {
    return obj ? Object.keys(obj) : [];
  }

  function findChildrenKeys(obj) {
    return Object.keys(obj).filter(key => Array.isArray(obj[key]) && obj[key].every(i => typeof i === 'object'));
  }

  function mergeKeys(keys1, keys2) {
    return Array.from(new Set([...keys1, ...keys2]));
  }

  function processNode(node, parentData = {}, parentKeys = []) {
    const nodeKeys = getKeys(node);
    const currentChildrenKeys = findChildrenKeys(node);

    if (childrenKeys.length === 0) {
      childrenKeys.push(...currentChildrenKeys);
    }

    const row = {};
    nodeKeys.forEach(k => {
      if (!childrenKeys.includes(k)) {
        row[k] = node[k];
      }
    });

    parentKeys.forEach(k => {
      if (!(k in row)) row[k] = '';
    });

    rows.push(row);

    currentChildrenKeys.forEach(childKey => {
      const childrenArray = node[childKey];

      childrenArray.forEach(childNode => {
        // qui NON pushiamo childRow, gestiamo tutto con la ricorsione
        processNode(childNode, row, mergeKeys(parentKeys, nodeKeys));
      });
    });
  }

  if (Array.isArray(data)) {
    data.forEach(item => processNode(item, {}, []));
  } else {
    processNode(data, {}, []);
  }

  return rows;
}

export default flattenJsonForExport;